import { InjectionToken } from '@angular/core';

/**
 * The upper bound of the random delay before the state is refetched after a transition.
 */
export const maintenanceTransitionRefetchMaxDelayMs = 30_000;

/**
 * Die Verzögerung, mit der diese Sitzung nach einer abgelaufenen Umschaltzeit nachfragt.
 *
 * Das Ende eines Fensters ist für alle gesperrten Sitzungen dieselbe Sekunde: ohne Streuung fragen alle
 * gleichzeitig nach und laden anschließend gleichzeitig die Anwendung neu - genau in dem Moment, in dem der
 * Host aus der Wartung zurückkommt. Gezogen wird die Verzögerung einmal je Sitzung (Fabrik des Tokens), nicht
 * je Sekundentakt. Die Entscheidung bleibt beim Server; gestreut wird nur der Zeitpunkt des Nachfragens.
 */
export const MAINTENANCE_TRANSITION_REFETCH_DELAY_MS = new InjectionToken<number>(
  'MaintenanceTransitionRefetchDelayMs',
  {
    providedIn: 'root',
    factory: () => Math.floor(Math.random() * maintenanceTransitionRefetchMaxDelayMs),
  },
);
